const EPSILON = 20;

export const SNAP_INIT = 0;
export const SNAP_CLOSE = 1;
export const SNAP_LEAVE = 2;

function Snap(map) {
  this.map = map;
  this.status = SNAP_INIT;
}

Snap.prototype.isClose = function isClose(latlngs) {
  const [point1, point2] = latlngs.map(ll =>
    this.map.project(ll, this.map.getZoom()),
  );
  const dx = point1.x - point2.x;
  const dy = point1.y - point2.y;
  const distance = Math.sqrt(dx * dx + dy * dy);
  return distance < EPSILON;
};

Snap.prototype.test = function test(latlngs) {
  if (this.status !== SNAP_INIT) {
    return this.status === SNAP_CLOSE;
  }
  const close = this.isClose(latlngs);
  this.status = close ? SNAP_CLOSE : SNAP_LEAVE;
  return close;
};

function getSnap(map) {
  return new Snap(map);
}

export default getSnap;
